const _excluded = ["inputService", "label", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from 'react';
import { getTheme } from 'office-ui-fabric-react';
import MaskedInput from 'react-text-mask';
import { msToTimestamp, timestampToMs } from 'buzz_lib_shared';
import { useInput } from '../../../machines/inputMachine/useInput';
import { Stack } from '../../Stack';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const theme = getTheme();
export const TimestampControl = _ref => {
  let {
      inputService,
      label,
      disabled = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });
  const inputFieldRef = React.useRef(null);
  const {
    name,
    value,
    errorMessage,
    send,
    touched
  } = useInput(inputService);
  const styles = {
    fontFamily: "'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    fontSize: '14px',
    fontWeight: '400',
    boxShadow: 'none',
    margin: '0px',
    padding: '0px 8px',
    boxSizing: 'border-box',
    color: theme.palette.neutralPrimary,
    width: '100%',
    minWidth: '0px',
    textOverflow: 'ellipsis',
    background: 'none transparent',
    outline: '0px',
    height: '32px',
    border: '1px solid',
    borderColor: errorMessage ? '#a80000' : theme.palette.neutralTertiary,
    borderRadius: '2px'
  };
  const [controlValue, setControlValue] = useState(value !== undefined ? msToTimestamp(value) : undefined);
  const handleBlur = event => {
    var _event$currentTarget;
    const newValue = (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.value;
    if (newValue === controlValue) {
      return;
    }
    setControlValue(newValue);
    send([{
      type: 'BLUR'
    }, {
      type: 'CHANGE',
      value: newValue.length > 0 ? timestampToMs(newValue) : undefined
    }, {
      type: 'COMMIT'
    }]);
  };
  const handleFocus = () => {
    send({
      type: 'FOCUS'
    });
  };
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsx(Stack, {
      children: /*#__PURE__*/_jsx(MaskedInput, _objectSpread(_objectSpread({}, props), {}, {
        ref: inputFieldRef,
        mask: [/[0-9]/, /[0-9]/, ':', /[0-5]/, /[0-9]/, ':', /[0-5]/, /[0-9]/],
        style: styles,
        name: name,
        value: controlValue !== null && controlValue !== void 0 ? controlValue : undefined,
        onBlur: handleBlur,
        onFocus: handleFocus,
        disabled: disabled,
        placeholder: "__:__:__",
        keepCharPositions: true
      }))
    }), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
};